
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obchodne-podmienky",
      function () {
        return require("private-next-pages/obchodne-podmienky.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obchodne-podmienky"])
      });
    }
  